import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './ExpiredBadge.module.scss';

function ExpiredBadge() {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.wrapper}>
      <span className={scss.badge}>{t('expired')}</span>
    </div>
  );
}

export default ExpiredBadge;
